// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

export function isOffice() {
  return (window.location.search.includes("office")
    || window.location.hostname.includes("office"))
}